import React from "react";
import { ManagePlanGroupContainer } from "../../../containers";

const ManagePlanGroup = (props) => {
  return <ManagePlanGroupContainer {...props} />;
};

export default ManagePlanGroup;
